import { PawPrint } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { PetPeek } from '@/components/PetPeek';

export const FinalCta = () => {
  const { t } = useLanguage();
  return (
    <section className="bg-brand-orange text-brand-cream py-24 px-4 sm:px-6 relative overflow-hidden" data-testid="final-cta">
      <PawPrint className="absolute -left-10 -top-10 w-64 h-64 text-white/10 rotate-[-20deg]" aria-hidden="true" />
      <PawPrint className="absolute -right-12 bottom-0 w-72 h-72 text-white/10 rotate-[25deg]" aria-hidden="true" />
      <PetPeek type="cat" className="top-6 right-8 hidden md:block" />
      <div className="max-w-4xl mx-auto text-center space-y-8 relative z-10">
        <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] tracking-tight">{t.finalCta.title}</h2>
        <p className="text-lg md:text-xl font-bold">{t.finalCta.sub}</p>
        <a
          href="#product"
          data-testid="final-cta-btn"
          className="inline-flex items-center justify-center px-12 py-5 rounded-full bg-brand-green text-brand-cream text-base font-extrabold uppercase tracking-wide hover:scale-95 transition-transform shadow-2xl"
        >
          {t.finalCta.cta}
        </a>
      </div>
    </section>
  );
};
